<script lang="ts" setup>
import VHeading from '@shared/typography/VHeading/VHeading.vue';
import { computed, toRefs } from 'vue';

import VSizeContainer, { type ContainerSize } from '../VSizeContainer/VSizeContainer.vue';

const props = withDefaults(
  defineProps<{
    /** Hoe breed de onderliggende VSizeContainer moet zijn. */
    containerSize?: ContainerSize;
    /** Vul beschikbare ruimte van parent op met content-container */
    fitContent?: boolean;
    /** Ruimte tussen de titel en de content. 'xs' is bedoeld voor pagina's die gebruik maken van NetFrameworkEmbed, om te compenseren voor padding op de .NET Framework pagina. */
    gap?: 'md' | 'xs';
    /** Tekst om te renderen in de titel. Wordt niet gebruikt als de #title slot gebruikd wordt. */
    title?: string;
  }>(),
  { gap: 'md' },
);

const { containerSize, gap, title } = toRefs(props);

const mobileSpacing = computed(() => (gap.value === 'xs' ? 'my-2' : 'my-4'));
const desktopSpacing = computed(() => (gap.value === 'xs' ? 'xl:my-2' : 'xl:my-8'));
</script>
<template>
  <VSizeContainer :size="containerSize" class="flex flex-col">
    <div class="mt-4 flex xl:mt-8">
      <div class="max-xl:hidden">
        <slot name="title">
          <VHeading :level="1">{{ title }}</VHeading>
        </slot>
      </div>

      <div class="ml-auto flex shrink-0 flex-wrap justify-end gap-x-4 gap-y-2 empty:hidden">
        <slot name="actions"></slot>
      </div>
    </div>
    <div
      :class="[
        mobileSpacing,
        desktopSpacing,
        {
          'h-0 grow overflow-auto': props.fitContent,
        },
      ]"
    >
      <slot></slot>
    </div>
  </VSizeContainer>
</template>
